/*
* Contains the javascript for the product pages under 
* "Starting Your Business" and "Managing Your Business Tabs"
*/
; (function (global, $, undefined) {
    'use strict';

    $(function () {
        // page: starting-your-business/international/located-outside-the-us
        $('#compare-pricing-btn').on('click', function (ev) {
            var packageIdMap = {
                'limited-liability-company-package': 167,
                'nonprofit-package': 168,
                'c-corporation-package': 166,
                's-corporation-package': 166
            };

            var businessType = $('#choose-business-type-select').val();
            var state = $('#choose-state-select').val();

            if (!(businessType && state)) {
                global.alert('Please select both Business Type and State.');
            } else {
                var id = packageIdMap[businessType];
                var isCCorp = businessType === 'c-corporation-package' ? 1 : 0;

                var pURL = '/package-select?EntityTypeId=' + id + '&IsCCorp=' + isCCorp + '&state=' + state;
                var pCurrentPageURL = document.location.href;
                if (pCurrentPageURL.toUpperCase().indexOf('/INTERNATIONAL/') > 0) {
                    pURL += '&international=Y';
                }
                global.open(pURL);
            }
        });
    });

} (window, jQuery));
